module.exports = __webpack_public_path__ + "img/image_2_4.649ef88e.png";